import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { DynamicTableWidgetService } from './dynamic-table-widget.service';
import { DynamicTableChildWidgetM, DynamicTableModuleWidgetM } from '../../models/dynamic-table/dynamic-table-module-widget.model';
import { MessageService } from 'primeng/api';


@Injectable({
    providedIn: 'root'
})
export class ModuleWidgetService {
    public moduleWidgetSubject = new BehaviorSubject<any[]>([]);

    constructor(private dynamicTableWidgetService: DynamicTableWidgetService, private messageService: MessageService) {
    }

    // Force refresh widgets (void method for simple refresh)
    forceRefreshWidgets(): void {
        this.dynamicTableWidgetService.getModuleWidgets().subscribe({
            next: (moduleWidgets: DynamicTableModuleWidgetM[]) => {
                this.moduleWidgetSubject.next(moduleWidgets);
            },
            error: (error) => {
                this.messageService.add({severity:'error', summary:'Error', detail:'Error refreshing widgets'});
            }
        });
    }

    getModuleWidgets(): Observable<DynamicTableModuleWidgetM[]> {
        return this.moduleWidgetSubject.asObservable();
    }

    // Add public getter to access current workbooks
    get currentModuleWidgets(): DynamicTableModuleWidgetM[] {
        return this.moduleWidgetSubject.value;
    }

    getModuleWidgetById(moduleId: number): DynamicTableModuleWidgetM | undefined {
        return this.moduleWidgetSubject.value.find(wb => wb.referenceId == moduleId);
    }

    getSystemSubModules(moduleName: string): DynamicTableChildWidgetM[] {
        return this.moduleWidgetSubject.value.find(wb => wb.name===moduleName && wb.metaData === "SystemDefined" && wb.childWidgets.length > 0)?.childWidgets?.filter(child => child.permissionType !== 0) || [];
    }

    getCustomSubModules(moduleId: number): DynamicTableChildWidgetM[] {
        return this.moduleWidgetSubject.value.find(wb => wb.referenceId == moduleId && wb.metaData === "CustomModule" && wb.childWidgets.length > 0)?.childWidgets?.filter(child => child.permissionType !== 0) || [];
    }
} 